import React from 'react'
import { Row, Button, Colors } from 'react-foundation'

require('../style/css/third_party/foundation.css')
require('../style/css/third_party/animate.css')

require('../style/scss/custom/main.scss')

require('../style/css/custom/components/thisWebsite.css')
require('../style/css/custom/components/apps.css')
require('../style/css/custom/icons.css')
require('../style/css/custom/main.css')

require('../js_animations/customAnimations.js')
require('../js_animations/scrollMagic.js')


const ThisWebsite = ({
  myEmail,
  myPhone,
  logo_white_PNG,
  logo_blue_PNG_960,
  logo_blue_PNG_100,
  logo_blue_PNG_70,
  logo_blue_PNG_16,

  copiedMessageClass_1,
  contactMeToggle,

  onCopy,
  contactButtonHover_ON_thisWebsite,
  contactButtonHover_OFF_thisWebsite,
  contactButtonClicked_thisWebsite
}) => (

<div id="this_website_enclosure"> {/* enclosure */}

<div className="this_website__text_header">
  <p className="wow bounceInUp " data-wow-offset="0">A</p><p className="wow bounceInUp  " data-wow-offset="100">B</p><p className="wow bounceInUp  " data-wow-offset="110">O</p><p className="wow bounceInUp  " data-wow-offset="120">U</p><p className="wow bounceInUp  " data-wow-offset="130">T</p> <p className="wow bounceInUp  " data-wow-offset="150">T</p><p className="wow bounceInUp  " data-wow-offset="160">H</p><p className="wow bounceInUp  " data-wow-offset="170">I</p><p className="wow bounceInUp  " data-wow-offset="180">S</p> <p className="wow bounceInUp  " data-wow-offset="200">W</p><p className="wow bounceInUp  " data-wow-offset="210">E</p><p className="wow bounceInUp  " data-wow-offset="220">B</p><p className="wow bounceInUp  " data-wow-offset="230">S</p><p className="wow bounceInUp  " data-wow-offset="240">I</p><p className="wow bounceInUp  " data-wow-offset="250">T</p><p className="wow bounceInUp  " data-wow-offset="260">E</p>
</div>
{
// Description, Buttons and Flying Icons
}
<Row className="apps__app" id="this_website" >

  <div className="wow slideInUp description_2" data-wow-offset="100" id="this_website_description">

    <p className="wow fadeIn" data-wow-offset="200">
      SONICLOUDS.NET is a living portfolio for the web development and design work of <a href="http://www.linkedin.com/in/soniclouds">David Chamberlin</a>.  The emphasis is on front-end development using advanced JavaScript, exploring a rich ecosystem of modern tools in a React/Redux environment.
    </p>
    <p className="wow fadeIn" data-wow-offset="215">
      The site is responsive and built for production, complete with CSS pre/post processing and autoprefixing, JS transpiling and minifying, and dedicated AWS microservices for content management and serving.  The visual and interactive elements are achieved using a variety of libraries and modules including <a href='http://foundation.zurb.com'>Foundation</a>, <a href='http://zurb.com/playground/motion-ui'>Motion UI</a>, and <a href='https://greensock.com/'>GreenSock</a>, as well as plenty of custom vanilla JavaScript, jQuery, and CSS.
    </p>
    <p className="wow fadeIn" data-wow-offset="175">
      This website also serves as a personal development playground for me to try out different and emerging technologies and continually improve my skills as a developer.  As a result of being 100% custom-made, <span className="bold">everything you see here is something I can do for you.</span>
    </p>
    {
    // CLICK TO COPY
    }
{
    // <div className="buttons_container">

    //   <div id='copiedMessage_thisWebsite'>
    //     <span className={copiedMessageClass_1}>copied!</span>
    //   </div>
    //   <CopyToClipboard text={myEmail} onCopy={onCopy}>
    //     <Button color={Colors.SUCCESS} isHollow className="description__contact_button wow fadeIn" data-wow-offset="90" onMouseEnter={contactButtonHover_ON_thisWebsite} onMouseLeave={contactButtonHover_OFF_thisWebsite} onClick={contactButtonClicked_thisWebsite} >{contactMeToggle}</Button>
    //   </CopyToClipboard>
    // </div>
    //
}
    <Button color={Colors.PRIMARY} isHollow className="description__code_button wow fadeIn" data-wow-offset="100"><a href="https://github.com/soniclouds/PORTFOLIO_v2">check out the code</a></Button>

    <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/React_1.png" alt="flyingIcon_ThisWebsite_React" className="flying-icon icon_React from-right" id="flyingIcon_ThisWebsite_React"/>

    <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Redux_1.png" alt="flyingIcon_ThisWebsite_Redux" className="flying-icon icon_Redux from-right" id="flyingIcon_ThisWebsite_Redux"/>

    <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/JavaScript_1.png" alt="flyingIcon_ThisWebsite_JavaScript" className="flying-icon icon_JavaScript from-right" id="flyingIcon_ThisWebsite_JavaScript"/>

    <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Node_1.png" alt="flyingIcon_ThisWebsite_Node" className="flying-icon icon_Node_2 from-right" id="flyingIcon_ThisWebsite_Node"/>

    <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/CSS3_1.png" alt="flyingIcon_ThisWebsite_CSS3" className="flying-icon icon_CSS3 from-left" id="flyingIcon_ThisWebsite_CSS3"/>

    <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/jQuery_1.png" alt="flyingIcon_ThisWebsite_jQuery" className="flying-icon icon_jQuery from-left" id="flyingIcon_ThisWebsite_jQuery"/>

    <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/HTML5_1.png" alt="flyingIcon_ThisWebsite_HTML5" className="flying-icon icon_HTML5 from-left" id="flyingIcon_ThisWebsite_HTML5"/>

    <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Foundation_1.png" alt="flyingIcon_ThisWebsite_Foundation" className="flying-icon icon_Foundation from-left" id="flyingIcon_ThisWebsite_Foundation"/>

    <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/AWS_2.png" alt="flyingIcon_ThisWebsite_AWS" className="flying-icon icon_AWS from-left" id="flyingIcon_ThisWebsite_AWS"/>

    <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Babel_1.png" alt="flyingIcon_ThisWebsite_Babel" className="flying-icon icon_Babel from-right" id="flyingIcon_ThisWebsite_Babel"/>

    <img src="https://s3-us-west-1.amazonaws.com/soniclouds-portfolio-assets/icons/Webpack_1.png" alt="flyingIcon_ThisWebsite_Webpack" className="flying-icon icon_Webpack from-right" id="flyingIcon_ThisWebsite_Webpack"/>

  </div>
</Row>
{
// closes this website
}


</div>
)

export default ThisWebsite



// WEBPACK FOOTER //
// ./src/components/thisWebsite.js